(function () {
  let isSwapping = false;

  function getProductSection(doc = document) {
    const product = doc.querySelector('[id^="MainProduct-"]');
    if (!product) {
      console.error('MainProduct not found');
      return null;
    }
    return product.closest('.shopify-section');
  }

  async function swapProduct(url, pushHistory = true) {
    if (isSwapping) return;

    const targetUrl = new URL(url, window.location.origin);

    // Same product
    if (targetUrl.pathname === window.location.pathname) {
      console.log('Already on this product');
      return;
    }

    isSwapping = true;

    try {
      console.log('1. Fetching:', targetUrl.href);

      const response = await fetch(targetUrl.href, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Fetch failed: ' + response.status);
      }

      const html = await response.text();
      console.log('2. HTML received');

      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');

      const currentSection = getProductSection(document);
      const newSection = getProductSection(newDoc);

      if (!currentSection) throw new Error('Current product section not found');
      if (!newSection) throw new Error('New product section not found');

      // ─── INSTANT SWAP (no waiting for images) ───
      currentSection.replaceWith(newSection);
      console.log('3. Product section replaced');

      // Update title
      const newTitle = newDoc.querySelector('title');
      if (newTitle) {
        document.title = newTitle.textContent;
      }

      // Update URL
      if (pushHistory) {
        window.history.pushState({ productAjax: true }, '', targetUrl.href);
      }

      console.log('4. URL updated:', window.location.href);

      // Shopify custom event
      document.dispatchEvent(
        new CustomEvent('product:ajax-swapped', {
          detail: { url: targetUrl.href }
        })
      );

      // Re-init Shopify Payment Button
      if (window.Shopify && Shopify.PaymentButton) {
        try {
          Shopify.PaymentButton.init();
        } catch (error) {
          console.warn('PaymentButton init failed', error);
        }
      }

      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'instant' });

      console.log('5. AJAX PRODUCT CHANGE SUCCESS');

    } catch (error) {
      console.error('AJAX PRODUCT ERROR:', error);
      // Do NOT fall back to location.href – that causes a full reload
    } finally {
      isSwapping = false;
    }
  }

  // ─── CLICK HANDLER ───
  document.addEventListener('click', function (e) {
    const container = e.target.closest('.flavour_item, .pack-box');
    if (!container) return;

    let link = null;
    if (container.tagName && container.tagName.toLowerCase() === 'a') {
      link = container;
    } else {
      link = container.querySelector('a');
    }

    let url = null;
    if (link) {
      url = link.getAttribute('href');
    } else {
      url = container.getAttribute('href');
    }

    if (!url || url === '#') {
      console.warn('No product URL found', container);
      return;
    }

    // Stop normal navigation completely
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();   // extra safety

    console.log('CLICKED PRODUCT:', url);
    swapProduct(url, true);
  }, true); // capture phase

  // ─── BACK / FORWARD ───
  window.addEventListener('popstate', function () {
    console.log('Browser back/forward:', window.location.href);
    swapProduct(window.location.href, false);
  });
})();
